export const loadSliderPeriodMiliseconds: number = 1 * 60 * 60 * 1000
